import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class AnomalieInterventionEvent extends UserEvent {
  public static NAME = 'ANOMALIE_INTER';

  constructor(
    public idVacation: string,
    public texte: string,
    public photos: string[],
    public avecZone: boolean,
    public idZone: string | undefined,
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates
  ) {
    super(AnomalieInterventionEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: AnomalieInterventionEvent): AnomalieInterventionEvent {
    return new AnomalieInterventionEvent(
      obj.idVacation,
      obj.texte,
      obj.photos,
      obj.avecZone,
      obj.idZone,
      dayjs(obj.instant),
      obj.coordinates
    );
  }
}
